import {Message} from "../helpers/IntlProps"

export namespace SIGN_UP_OPTION {
    export const ECOM_MANAGEMENT = "ecom_management"
    export const RUN_BRICK_AND_MORTAR = "run_brick_and_mortar"
    export const SELL_B2B = "sell_b2b"
    export const SELL_TO_CUSTOMERS = "sell_customers"
    export const WEB_AGENCY = "web_agency"
}
export type SIGN_UP_OPTION = typeof SIGN_UP_OPTION[keyof typeof SIGN_UP_OPTION];


export namespace START_UP_GUIDE_OPTION {
    export const REQUEST_A_QUOTE_FORM = "request_a_quote_form"
    export const ADD_TO_QUOTE_BUTTON = "add_to_quote_button"
    export const HIDE_PRICE_ON_PRODUCT = "hide_prices_on_products"
    export const SEND_QUOTES = "send_quotes"
    export const SEND_INVOICES = "send_invoices"
    export const DIGITAL_SIGNATURE = "digital_signature"
    export const ACCOUNTS_RECEIVABLE = "accounts_receivable"
    export const TRACK_OPEN_DEALS = "track_open_deals"
    export const IPAD_FOR_POS_SHOPIFY = "ipad_for_pos_shopify"
    export const PAYMENT_TERMS = "payment_terms"
    export const ONLINE_PAYMENTS = "online_payments"
    export const PARTIAL_PAYMENTS_AND_DEPOSITS = "partial_payments_and_deposits"
    export const SCHEDULE_APPOINTMENTS = "schedule_appointments"
    export const SELL_ON_SOCIAL_MEDIA = "sell_on_social_media"
    export const SEND_SPECIAL_OFFERS = "send_special_offers"
}
export type START_UP_GUIDE_OPTION = typeof START_UP_GUIDE_OPTION[keyof typeof START_UP_GUIDE_OPTION];


export namespace START_UP_GUIDE_TYPE {
    export const INTERCOM_ARTICLE = "intercom-guide"
    export const REDIRECT = "redirect-guide"
}
export type START_UP_GUIDE_TYPE = typeof START_UP_GUIDE_TYPE[keyof typeof START_UP_GUIDE_TYPE];

export type START_UP_GUIDE = {
    guideType: START_UP_GUIDE_TYPE,
    articleID: number,
    redirectUrl: string,
    guideLabel: Message,
}

export type START_UP_GUIDES = {
    descriptionMessage: Message,
    guides: Array<START_UP_GUIDE>
}



// WEBPACK FOOTER //
// ./src/state/onboarding/DataFlowTypes.ts